import { observer } from 'mobx-react-lite';
import React from 'react';
import ButtonLoader from '@components/ButtonLoader/ButtonLoader';
import './ForgetPassword-animations.scss';
import { useMst } from '@store/Route';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2'

const ForgetPassword = observer(() => {
  const { landing } = useMst();
  const { setToggleShowPasswordPanel, forgetPassword, fetchingForgetPassword} = landing;

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email address').required('Email is required'),
    }),
    onSubmit: values => {
      forgetPassword(values.email, () => {
        Swal.fire({
          icon: 'success',
          title: 'Password reset link has been sent to your email',
        })
      })
    },
  });

  return (
    <section className="ForgetPassword__animOnboard">
      <form onSubmit={(e) => {
        formik.handleSubmit();
        e.preventDefault();
      }}>
        <div className="actions__header">
          <h1>Forgot your password?</h1>
          <h1>Reset your password.</h1>
        </div>
        <p className="actions__copy mb-4">
          Type in the email you registered your
          account with, and we will provide you a link to reset your password.
        </p>
        <div className="formElements__group">
          <label
            className="formElements__label"
            htmlFor="email"
          >
            Email Address

          </label>
          <input
            className="w-100 formElements__input formElements--inputText form-control"
            type="email"
            {...formik.getFieldProps('email')}
            required
          />
           {formik.touched.email && formik.errors.email ? (
					    <div className='formElements__errorText'>{formik.errors.email}</div>
				    ) : null}
          <div className="invalid-feedback" />
        </div>
        <p className="color--red body--14 mt-3 mb-4" />
        <p className="color--green body--14 mt-3 mb-4">
          {}
        </p>
        <ButtonLoader
          type="submit"
          className="w-100 mt-3"
          isLoading={fetchingForgetPassword === 'pending'}
        >
          Submit
        </ButtonLoader>
        <p
          className="mt-5 mb-3 w-100 body--14 text-center formElements__inlineClicky"
          onClick={() => {
            setToggleShowPasswordPanel(false);
          }}
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}
        >
          Back to Login
        </p>
      </form>
    </section>
  );
});

export default ForgetPassword;
